/**
 * @desc 保存和编辑
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageCategory.save.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageCategory/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
